import { useSelector } from "react-redux";
import "./style.scss";
import { useEffect, useState } from "react";

function Notification(props) {
  const [notificationClass, setNotificationClass] = useState("");
  const notificationState = useSelector((state) => state.notification);

  useEffect(() => {
    if (notificationState.show) {
      setNotificationClass("show");
    } else {
      setNotificationClass("");
    }
  }, [notificationState.show]);

  return notificationState.show ? (
    <div className="notification">
      <div className={"modal fade " + notificationClass}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{notificationState.title}</h5>
            </div>
            <div className="modal-body">{notificationState.content}</div>
            <div className="modal-footer">{notificationState.buttonGroup}</div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
}

export default Notification;
